// extracted by mini-css-extract-plugin
export default {"eyebrow":"Eyebrow_eyebrow__NsTc8"};